import { render } from "./GamificationAccomplishments.vue?vue&type=template&id=75d42069"
import script from "./GamificationAccomplishments.vue?vue&type=script&lang=js"
export * from "./GamificationAccomplishments.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__